/**
 * Solidly Meet mark — exact geometry from the brand vector master
 * (static/logo-master.svg), minus the light plate so it sits on any
 * background. Renders in `currentColor`; set the color via CSS on the parent.
 */
const Logo = ({ size = 26, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 102 102"
    className={className}
    role="img"
    aria-label="Solidly Meet"
    fill="none"
  >
    {/* Diamond ring */}
    <rect x="2.82843" y="50.7593" width="67.7845" height="68.4653" rx="6" transform="rotate(-45 2.82843 50.7593)" fill="none" stroke="currentColor" strokeWidth="4" />
    {/* Center node */}
    <ellipse cx="51.0062" cy="51.5983" rx="13.5638" ry="13.5638" fill="currentColor" />
    {/* E node + fillets */}
    <rect x="68.2314" y="51.2388" width="23.8723" height="23.8723" rx="8" transform="rotate(-45 68.2314 51.2388)" fill="currentColor" />
    <rect x="80.2695" y="63.2764" width="8.21895" height="6.83563" transform="rotate(-45 80.2695 63.2764)" fill="currentColor" />
    <rect x="79.1885" y="40.2822" width="8.35712" height="6.62508" transform="rotate(-45 79.1885 40.2822)" fill="currentColor" />
    {/* S node + fillets */}
    <rect x="34.3545" y="85.1157" width="23.8723" height="23.8723" rx="8" transform="rotate(-45 34.3545 85.1157)" fill="currentColor" />
    <rect x="34.3779" y="85.092" width="8.34976" height="8.80824" transform="rotate(-45 34.3779 85.092)" fill="currentColor" />
    <rect x="56.0283" y="83.9255" width="7.70499" height="9.37049" transform="rotate(-45 56.0283 83.9255)" fill="currentColor" />
    {/* W node + fillets */}
    <rect y="50.7612" width="23.8723" height="23.8723" rx="8" transform="rotate(-45 0 50.7612)" fill="currentColor" />
    <rect x="11.2744" y="39.5442" width="7.9678" height="9.08424" transform="rotate(-45 11.2744 39.5442)" fill="currentColor" />
    <rect x="10.4932" y="61.2212" width="8.35988" height="9.05413" transform="rotate(-45 10.4932 61.2212)" fill="currentColor" />
    {/* N node + fillets */}
    <rect x="33.8682" y="16.8804" width="23.8723" height="23.8723" rx="8" transform="rotate(-45 33.8682 16.8804)" fill="currentColor" />
    <rect x="33.8867" y="16.9033" width="7.47196" height="9.37152" transform="rotate(-45 33.8867 16.9033)" fill="currentColor" />
    <rect x="56.0283" y="16.0581" width="7.59742" height="8.78407" transform="rotate(-45 56.0283 16.0581)" fill="currentColor" />
  </svg>
);

export default Logo;
